module.exports = __webpack_public_path__ + "img/hefei.1fdbf8ee.png";